/*
 * @Description  :
 * @Author       : 王帅
 * @Date         : 2022-10-18 09:55:10
 * @LastEditors  : 王帅
 * @LastEditTime : 2025-10-28 16:16:29
 * @FilePath     : \ngs_share_login\src\utility\prototype.js
 */
import Vue from 'vue'

// 建立操作缓存
Vue.prototype.$operatingCache = {
	set: function(routeName, val) {
		bmStorage.sessionStorage.set(routeName, JSON.stringify(val))
	},

	get: function(routeName) {
		var data = bmStorage.sessionStorage.get(routeName)
		return JSON.parse(data)
	}
}

// 建立socket
Vue.prototype.$socket = function(userId, tenantId) {
	let ws = new WebSocket(process.env.VUE_APP_SOCKET_URL + userId)
	let sendFn = null

	ws.onopen = function(e) {
		sendFn = setInterval(() => {
			ws.send('1')
		}, 30000)
		Vue.prototype.$socketOpen(e)
	}

	ws.onmessage = function(e) {
		Vue.prototype.$socketMessage(e)
	}

	ws.onclose = function(e) {
		clearInterval(sendFn)
		Vue.prototype.$socketClose(e)
	}
}

Vue.prototype.$socketOpen = function(e) {
	// console.log('open', e)
}

Vue.prototype.$socketMessage = function(e) {
	// console.log('message', e)
}

Vue.prototype.$socketClose = function(e) {
	console.log('socketClose', e)
	// window.location.href = 'about:blank'
	// window.close()
	if (Vue.$router) {
		Vue.$router.push({ name: 'tip' })
	}
}

// 预览方法
import { previewFn } from './tools'
Vue.prototype.$previewFn = previewFn

// 生成默认随机数
import { generateRandomString } from './tools'
Vue.prototype.$generateRandomString = generateRandomString

// 自定义下载文件名
import { downloadFile } from './tools'
Vue.prototype.$downloadFile = downloadFile



// WEBPACK FOOTER //
// ./src/utility/prototype.js